<div>
	<div fxLayout="column" fxFill fxLayoutAlign="flex-end flex-end">
		<button mat-icon-button (click)="onCloseClick()">
			<img
				src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/crossBlack/public"
			/>
		</button>
	</div>
	<mat-dialog-content>
		<p
			i18n="@@shareUpdate_sendUpdateEmail_confirmationNote"
			class="mat-typography"
		>
			Are you sure that you want to send this email to all the donors, this
			action will be done only once.
		</p>
	</mat-dialog-content>
	<mat-dialog-actions align="end">
		<button mat-flat-button (click)="onCloseClick()" i18n="@@button_close">
			Close
		</button>
		<button
			mat-flat-button
			color="accent"
			i18n="@@button_sendEmail"
			(click)="sendUpdateEmail()"
		>
			Send Email
		</button>
	</mat-dialog-actions>
</div>
